import { Field, Form, useFormikContext } from 'formik'
import { FieldSet, ActionLink } from 'app/_shared'
import Error from '../Error'

export default ({children}) => {
  const { isSubmitting } = useFormikContext();
  return (
    <Form>
      {children}
      <Field type="hidden" name="email" />
      <FieldSet name="code" label="Verfication code"  />
      <Error />
      <ActionLink type="submit" appearance="button" disabled={isSubmitting}>Confirm code</ActionLink>
    </Form>
  )
}
